import * as React from 'react';

import { GlobalDatingTrendsContainer } from 'containers/project-love/global-dating-trends/global-dating-trends-container';

const GlobalDatingTrendsPage: React.FunctionComponent = (props) => {
  return <GlobalDatingTrendsContainer {...props} />;
};

export default GlobalDatingTrendsPage;

export { getServerSideProps } from 'lib/global-dating-trends/get-server-side-props';
